import { DefaultPreviewOption, PreviewModalOption } from '../previewModal'

interface State {
  formData: any
  previewModalOption: PreviewModalOption
}
type ActionType =
  | 'setFormDataAction'
  | 'setPreviewModalOptionAction'
  | 'resetStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  previewModalOption: DefaultPreviewOption,
}

export function reducer(state: State = initialState, action: Action): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setPreviewModalOptionAction':
      newstate.previewModalOption = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('no match actions')
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setPreviewModalOptionAction = (
  val: PreviewModalOption,
): Action => ({
  type: 'setPreviewModalOptionAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
import { DefaultPreviewOption, PreviewModalOption } from '../previewModal'

interface State {
  formData: any
  previewModalOption: PreviewModalOption
}
type ActionType =
  | 'setFormDataAction'
  | 'setPreviewModalOptionAction'
  | 'resetStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  previewModalOption: DefaultPreviewOption,
}

export function reducer(state: State = initialState, action: Action): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setPreviewModalOptionAction':
      newstate.previewModalOption = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('no match actions')
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setPreviewModalOptionAction = (
  val: PreviewModalOption,
): Action => ({
  type: 'setPreviewModalOptionAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
